import {
  ActionTypes,
  FetchUserProfileFailAction,
  FetchUserProfileStartAction,
  FetchUserProfileSuccessAction,
  cleanUserProfileAction,
} from './types';

import { UserProfile } from '@/types/legacyUserProfile';

const fetchUserProfileSuccess = (payload: UserProfile): FetchUserProfileSuccessAction => ({
  type: ActionTypes.FETCH_USER_PROFILE_SUCCESS,
  payload,
});
const cleanUserProfile = (): cleanUserProfileAction => ({
  type: ActionTypes.CLEAN_USER_PROFILE,
});
const fetchUserProfileStart = (): FetchUserProfileStartAction => ({
  type: ActionTypes.FETCH_USER_PROFILE_START,
});

const fetchUserProfileFail = (payload: string): FetchUserProfileFailAction => ({
  type: ActionTypes.FETCH_USER_PROFILE_FAIL,
  payload,
});

export { fetchUserProfileSuccess, fetchUserProfileStart, fetchUserProfileFail, cleanUserProfile };
